import { bl_sfa_project_ext_RowClass } from "../../../dbschema/bl_sfa_project_ext.model";
import { bl_sfa_project_hdr_RowClass } from "../../../dbschema/bl_sfa_project_hdr.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaProjectContainerModel extends BaseContainerModel {
    bl_sfa_project_hdr: bl_sfa_project_hdr_RowClass = new bl_sfa_project_hdr_RowClass();
    bl_sfa_project_exts: bl_sfa_project_ext_RowClass[] =[];
}